import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  inject,
} from '@angular/core'

@Directive({
  selector: '[wmFrontAutofocus]',
  standalone: true,
})
export class AutofocusDirective implements AfterViewInit {
  /** Whether directive should be active or not */
  @Input() public wmFrontAutofocus: boolean

  private host = inject(ElementRef)

  public ngAfterViewInit(): void {
    if (this.wmFrontAutofocus) {
      this.host.nativeElement.focus()
    }
  }
}
